import { useEffect } from "react";
import { useProcedureSessionTableShell } from "../../../../hooks/audit/useProcedureSessionTableShell";

interface AnalyticsColumnProbeProps {
  procedureSessionId: string;
  onChange: (procedureSessionId: string, hasAnalyticsColumn: boolean) => void;
}

/**
 * Reports whether one procedure session's table-shell carries an analytics
 * column. Renders nothing; it exists because the envelope has no columns and
 * a parent cannot call the table-shell hook once per procedure session. The
 * work paper below already loads the same shells, so this adds no fetch.
 */
export const AnalyticsColumnProbe = ({
  procedureSessionId,
  onChange,
}: AnalyticsColumnProbeProps) => {
  const { data } = useProcedureSessionTableShell(procedureSessionId);
  const hasAnalyticsColumn = Boolean(
    data?.procedure.columns.some((column) => column.analyticsColumn),
  );

  useEffect(() => {
    onChange(procedureSessionId, hasAnalyticsColumn);
  }, [procedureSessionId, hasAnalyticsColumn, onChange]);

  return null;
};
